<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="平台" prop="plat">
        <a-select v-model="formData.plat" placeholder="请选择平台">
          <a-select-option value="android">安卓</a-select-option>
          <a-select-option value="ios">苹果</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="app标识" prop="appId"
        ><a-input v-model="formData.appId" :maxLength="20"
      /></a-form-model-item>

      <a-form-model-item label="版本号" prop="version"
        ><a-input v-model="formData.version" :maxLength="20"
      /></a-form-model-item>

      <a-form-model-item label="安装包地址" prop="packageUrl"
        ><a-input v-model="formData.packageUrl"
      /></a-form-model-item>

      <a-form-model-item label="内部版本号" prop="insideVersion">
        <a-input-number v-model="formData.insideVersion" :min="1" :max="9999999"
      /></a-form-model-item>

      <a-form-model-item label="升级内容" prop="content"
        ><a-input v-model="formData.content" type="textarea" :maxLength="200"
      /></a-form-model-item>

      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否最新"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 8 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isNew == 'T' ? true : false"
              @change="onChange('isNew')"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="是否强制升级"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 8 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isForced == 'T' ? true : false"
              @change="onChange('isForced')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否浏览器下载"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 8 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.browser == 'T' ? true : false"
              @change="onChange('browser')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "DistrictInfo",
  props: {
    provinceList: {
      type: Array,
      default() {
        return [];
      }
    },
    cityList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        appId: "",
        version: "",
        insideVersion: 0,
        content: "",
        isNew: "F",
        isForced: "F",
        sta: "R",
        packageUrl: "",
        plat: "",
        browser: "F",
        loadingColor: "",
        windowHeight: ""
      },
      //form rules
      rules: {
        plat: [
          {
            required: true,
            message: "请选择平台",
            trigger: "change"
          }
        ],
        appId: [
          {
            required: true,
            message: "请输入app标识",
            trigger: "change"
          }
        ],
        version: [
          {
            required: true,
            message: "请输入版本号",
            trigger: "change"
          }
        ],
        insideVersion: [
          {
            required: true,
            message: "请输入内部版本号",
            trigger: "change"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入升级内容",
            trigger: "change"
          }
        ],
        packageUrl: [
          {
            required: true,
            message: "请输入安装包地址",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加版本" : "编辑版本";
      this.modal.type = type;
      if (type == "edit") {
        this.formData = Object.assign({}, data);
      } else {
        this.formData.plat = data.plat;
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        sta: "R",
        isNew: "F",
        isForced: "F",
        browser: "F"
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveAppVersion";
          if (this.modal.type == "edit") {
            action = "modifyAppVersion";
          }
          this.$http.roomBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>
